
import { Vue, Component } from 'vue-property-decorator';
import { Toast } from 'vant';

Vue.use(Toast);

@Component
export default class Link extends Vue {
  link = 'https://activity.cqcb.com/shangyou_activity/2026h1/0403yspxpc/home';

  copy() {
    Toast('复制成功');
  }
}
